/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Step_VerifyInputs */

const en_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify`)
};

const de_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfen`)
};

const fr_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier`)
};

const es_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar`)
};

const it_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica`)
};

const nl_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiëren`)
};

const pl_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja`)
};

const fi_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista`)
};

const da_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificer`)
};

const sv_onboarding_step_verify = /** @type {(inputs: Onboarding_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiera`)
};

/**
* | output |
* | --- |
* | "Verify" |
*
* @param {Onboarding_Step_VerifyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_verify = /** @type {((inputs?: Onboarding_Step_VerifyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_VerifyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_step_verify(inputs)
	if (locale === "fr") return fr_onboarding_step_verify(inputs)
	if (locale === "es") return es_onboarding_step_verify(inputs)
	if (locale === "it") return it_onboarding_step_verify(inputs)
	if (locale === "nl") return nl_onboarding_step_verify(inputs)
	if (locale === "pl") return pl_onboarding_step_verify(inputs)
	if (locale === "fi") return fi_onboarding_step_verify(inputs)
	if (locale === "da") return da_onboarding_step_verify(inputs)
	if (locale === "sv") return sv_onboarding_step_verify(inputs)
	return en_onboarding_step_verify(inputs)
});